import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { Reveal } from '../../ui/Reveal/Reveal';
import './About.css';

export function About() {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);

  return (
    <section id="about" className="section about">
      <div className="container">
        <div className="about__head">
          <Reveal>
            <span className="eyebrow">The Studio</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="about__title display-lg">
              We build the rooms that <span className="italic-accent">people remember</span> —
              quietly, and at scale.
            </h2>
          </Reveal>
        </div>

        <div className="about__grid">
          <div className="about__col">
            <Reveal delay={0.05}>
              <p className="about__lede">
                Luminar is a multidisciplinary events studio. Strategists, designers, broadcast
                engineers, lighting directors and concierge hosts under one roof. We do the obvious
                things obsessively — and the invisible ones twice.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="about__body">
                We've staged everything from intimate ceremonies in heritage palaces to stadium
                concerts with half a million guests across three continents. Our team has produced
                for the world's most demanding brands, families and governments — and we still take
                the same notebook to the first meeting.
              </p>
            </Reveal>

            <div className="about__pillars">
              {[
                { k: 'Discipline', v: 'Production runs like a touring crew, not a side hustle.' },
                { k: 'Discretion', v: 'Names stay private. Reputations stay protected.' },
                { k: 'Detail', v: 'The seam you do not see is the one we worked hardest on.' },
              ].map((p, i) => (
                <Reveal key={p.k} delay={0.2 + i * 0.08}>
                  <div className="about__pillar">
                    <span className="about__pillar-k">{p.k}</span>
                    <span className="about__pillar-v">{p.v}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div ref={ref} className="about__media">
            <motion.div className="about__media-inner" style={{ y }}>
              <img
                src="/images/1492684223066-81342ee5ff30.webp"
                alt="Luminar production"
                loading="lazy"
              />
            </motion.div>
            <div className="about__media-frame" />
            <div className="about__media-caption">
              <span>Volt Stadium Tour</span>
              <span>Bengaluru — 2024</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
